import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import './style.scss'

const ScanIndicator = () => {
  const { scanStatus, lastScan } = useSelector((s) => s.scanner)
  const [visible, setVisible] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (scanStatus === 'processing') {
      setMessage('📡 Memindai...')
      setVisible(true)
    } else if (scanStatus === 'success') {
      setMessage('✅ Berhasil')
      setVisible(true)
      const timer = setTimeout(() => setVisible(false), 2000)
      return () => clearTimeout(timer)
    } else if (scanStatus === 'error') {
      setMessage('❌ Tidak ditemukan')
      setVisible(true)
      const timer = setTimeout(() => setVisible(false), 2500)
      return () => clearTimeout(timer)
    } else {
      setVisible(false)
    }
  }, [scanStatus, lastScan?.timestamp])

  if (!visible) return null

  return (
    <div
      className={`scan-indicator scan-indicator--${scanStatus}`}
      data-testid="scan-indicator"
    >
      <span className="scan-indicator__text">{message}</span>
    </div>
  )
}

export default ScanIndicator
